var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "36px",
    height: "36px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M288,204.7c0,23.2-18.8,42-42,42H54c-23.2,0-42-18.8-42-42v-108c0-23.2,18.8-42,42-42h192c23.2,0,42,18.8,42,42V204.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 156.7,
    fill: "#010101",
    width: 48,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 180.7,
    fill: "#010101",
    width: 96,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M218.4,204.7c0-8.9,4.9-16.5,12-20.7c-3.5-2.1-7.6-3.3-12-3.3c-13.3,0-24,10.7-24,24c0,13.2,10.7,24,24,24 c4.4,0,8.5-1.3,12-3.3C223.3,221.2,218.4,213.6,218.4,204.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M242.4,204.7c0-8.9-4.9-16.5-12-20.7c3.5-2.1,7.6-3.3,12-3.3c13.2,0,24,10.7,24,24c0,13.2-10.8,24-24,24 c-4.4,0-8.5-1.3-12-3.3C237.6,221.2,242.4,213.6,242.4,204.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCard);
export default __webpack_public_path__ + "static/media/Icon_Card.bee2a9a37cb3eac6a84371665ddc8036.svg";
export { ForwardRef as ReactComponent };